import { InputAutofocusDirective } from './autofocus.directive';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [
    InputAutofocusDirective
  ],
  exports: [
    InputAutofocusDirective
  ]
})
export class DirectivesModule { }
